import React from 'react';

import { IllustrationProps } from './Illustration.types';
import IllustrationTokens from '../../generated/base/illustrations';
import { ratioMap } from '../../generated/base/ratios';
import { sizeToRadiusMap, buildQueryString } from '../utils';

function Illustration(props: IllustrationProps) {
	const { className, illustrationToken, size='medium', hasCornerRadius = false, altText = '', mode = 'light' } = props;
	const { url, ratio } = IllustrationTokens[illustrationToken];

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const dimensions = ratioMap[ratio][size];
	const thisClass = hasCornerRadius ? `${className} ${sizeToRadiusMap[size]}` : className
	const fullUrl = url + buildQueryString({ mode, size });	

	return <img className={thisClass} src={fullUrl} alt={altText} style={dimensions} />;
}

export default Illustration;
